import React, { createContext, useContext, useRef, useCallback, useMemo } from "react"
import PropTypes from "prop-types"

const SaveContext = createContext(null)

export const SaveProvider = ({ children }) => {
  const saveCallbackRef = useRef(null)

  const registerSaveCallback = useCallback((callback) => {
    saveCallbackRef.current = callback
  }, [])

  const unregisterSaveCallback = useCallback(() => {
    saveCallbackRef.current = null
  }, [])

  const triggerSave = useCallback((onComplete) => {
    if (saveCallbackRef.current) {
      saveCallbackRef.current(onComplete)
    } else if (onComplete) {
      // No save callback registered, just complete
      onComplete()
    }
  }, [])

  const contextValue = useMemo(
    () => ({ registerSaveCallback, unregisterSaveCallback, triggerSave }),
    [registerSaveCallback, unregisterSaveCallback, triggerSave]
  )

  return (
    <SaveContext.Provider value={contextValue}>
      {children}
    </SaveContext.Provider>
  )
}

SaveProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export const useSaveContext = () => {
  const context = useContext(SaveContext)
  if (!context) {
    throw new Error("useSaveContext must be used within a SaveProvider")
  }
  return context
}
